import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import useConfig from "hooks/useConfig";

interface TopBarProps {
  title: string | JSX.Element;
  showBackButton?: boolean;
  position?: "fixed" | "relative";
  onBackButtonClick?: () => void;
}

const TopBar = (props: TopBarProps) => {
  const { isInWebview } = useConfig();
  const { title, showBackButton = true, position, onBackButtonClick } = props;

  const handleBackButtonClick = () => {
    if (onBackButtonClick) {
      onBackButtonClick();
      return false;
    }

    if (!onBackButtonClick) {
      if (location.href.includes("test")) {
        window.location.href = "https://platform-test.funplus.com/stateofsurvival";
      } else {
        window.location.href = "https://zone.funplus.com/stateofsurvival/";
      }
    }
  };

  return (
    <Box sx={{ flexGrow: 1, pt: isInWebview ? "46px" : 0, background: "#fff" }}>
      <AppBar position="static" sx={{ background: "none", boxShadow: "none" }}>
        <Toolbar
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            fontSize: "18px",
            lineHeight: "25px",
            padding: "10px 23px",
            background: "#fff"
          }}
        >
          {showBackButton && (
            <IconButton
              size="small"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleBackButtonClick}
              sx={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "26px",
                cursor: "pointer",
                zIndex: "2"
              }}
            >
              <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.3224 18.2903L27.0837 5.00231C27.8951 4.21889 27.8951 2.94881 27.0837 2.16666C26.2722 1.38325 24.9581 1.38325 24.1467 2.16666L8.91617 16.8732C8.10477 17.6566 8.10477 18.9267 8.91617 19.7088L24.1466 34.414C24.5523 34.8057 25.0841 35.0009 25.6158 35.0009C26.1475 35.0009 26.6793 34.8057 27.0836 34.4126C27.895 33.6292 27.895 32.3604 27.0836 31.5769L13.3224 18.2903Z"
                  fill="#272636"
                />
              </svg>
            </IconButton>
          )}
          <Typography
            variant="h1"
            component="div"
            sx={{ color: "#000", textAlign: "center", fontSize: "16px", fontWeight: "400", lineHeight: "22px" }}
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default TopBar;
